import { Pie, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
    extends: Pie,
    mixins: [reactiveProp],
    props: {
        chartData: Object,
        options: Object
    },
    mounted() {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
        this.renderChart(this.chartData, this.options)
        /* this.renderChart({
            responsive: true,
            maintainAspectRatio: true
        }) */
    }
}
